module.exports = __webpack_public_path__ + "img/user-4.df41d886.svg";